import React, { ReactNode } from 'react';
import { List, ListItem, SxProps, Theme } from '@mui/material';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly children?: ReactNode;
}

export function PropertyList({ sx, children }: Props) {
  return (
    <List dense sx={[{ width: '100%' }, ...(Array.isArray(sx) ? sx : [sx])]}>
      {React.Children.toArray(children)
        .filter((child) => child != null)
        .map((child, i) => (
          <ListItem dense key={i} sx={{ marginBottom: 1 }}>
            {child}
          </ListItem>
        ))}
    </List>
  );
}
